import * as React from 'react';
import Viewer from './viewer';
import styles from './index.module.sass'
import { Simulation, ControllBoxStep, CounterStep } from 'types/data';
import { Engine } from './Engine';
import WaterTrack from './WaterTrack';
import LeversTrack from './LeversTrack';
import { Effect } from 'lib/sound';
import FreestyleState, { StatefulFreestyleItem } from 'types/freestyle.types';
import { connect } from 'react-redux';
import *as freestyleActions from 'actions/freestyle';
import { bindActionCreators } from 'redux';
import { GlobalState } from 'reducers';
import { getActiveItemObject } from 'selectors/commonSelectors';
import UserCameraControls from './UserCameraControls';

interface SceneProps {
  setViewerApi: Function,
  viewerApi?: Viewer,
  setSimulationSelect: Function,
  showButton: Boolean,
  isSimulationProgress: Boolean,
  activeSimulation?: Simulation,
  isRemote: Boolean,
  setSimulationSidePanelActive: Function,
  endActiveSimulation: Function,
  freestyleActive: boolean,
  showLevers: Boolean,
  setPositionReady: Function,
  positionReady: Boolean,
  currentCounterStep?: CounterStep,
  isDone: Boolean,
  afterLeverAnimationProgress: Boolean,
  setAVSP: Function,
  setContentOpened: Function,
  freestyle: FreestyleState,
  boxActiveStep?: ControllBoxStep,
  boxButtonPressed: Function,
  setNextSimulationStep: Function,
  simulationSelectActive: Boolean,
  initFreestyle: () => void,
  stopFreestyle: () => void,
  setFreestyleApi: (...args: Parameters<typeof freestyleActions.setFreestyleApi>) => void,
  ThrowButtonEvent: (...args: Parameters<typeof freestyleActions.ThrowButtonEvent>) => void
  incrementCounter: (...args: Parameters<typeof freestyleActions.incrementCounter>) => void
  freestyleActiveSimulation?: StatefulFreestyleItem
}



//@ts-ignore
const landingAudio = new Effect(window.webkitAudioContext ? './environment/urban.mp3' :  './environment/urban.ogg', () => {}, true)

const Scene: React.FunctionComponent<SceneProps> = ({ 
  showLevers, 
  ThrowButtonEvent,
  freestyle,
  isRemote, 
  positionReady,
  endActiveSimulation, 
  currentCounterStep,
  isSimulationProgress, 
  setSimulationSidePanelActive, 
  activeSimulation, 
  setViewerApi, 
  viewerApi, 
  setSimulationSelect, 
  initFreestyle,
  setNextSimulationStep,
  setPositionReady,
  afterLeverAnimationProgress,
  setContentOpened,
  freestyleActiveSimulation,
  freestyleActive,
  boxActiveStep,
  setAVSP,
  setFreestyleApi,
  stopFreestyle,
  boxButtonPressed,
  simulationSelectActive,
  incrementCounter,
  isDone
}) => {
  const [blurTransition, setBlurTransition] = React.useState(250)
  const [blur, setBlur] = React.useState<Boolean>(true)
  const [shade, setShade] = React.useState<Boolean>(false)
  const [blurRatio, setBlurRatio] = React.useState(91.3)
  const [enginePower, setEnginePower] = React.useState(0)
  const viewerNode = React.useRef(null)
  const laversDom = React.useRef<HTMLDivElement>(null)
  const canvasNode = React.useRef(null)
  const viewerLoaded = viewerApi && viewerApi.loaded
  const waterTrack = React.useRef<HTMLDivElement>(null)
  const isReverseLevers = Boolean(activeSimulation && activeSimulation.manual.reverse)
  const isEngine = Boolean(activeSimulation && activeSimulation.counter && activeSimulation.counter.type === 'engine')
  const isFreestyleEngine = Boolean(freestyleActiveSimulation && freestyleActiveSimulation.counter && freestyleActiveSimulation.counter.type === 'graphicState')

  const freestyleEnginePower = isFreestyleEngine ? freestyleActiveSimulation!.counter!.current  + 1 : 1

  React.useEffect(() => {
    if(viewerApi) {
      viewerApi!.isReverseLevers = isReverseLevers
    }
  },[isReverseLevers, viewerApi])
  
  React.useEffect(() => {
    if(isRemote && viewerApi && currentCounterStep) {
      if(currentCounterStep.isFirst) {
        viewerApi.RemoteControler.greenButtonReset()
      }
      viewerApi.updateCurrentCounterSteps(currentCounterStep, () => {
        !currentCounterStep.isLast ? 
          setNextSimulationStep()
          :
          endActiveSimulation()
        setContentOpened(true)
      })
    }
  }, [currentCounterStep, viewerApi, isRemote, endActiveSimulation, setContentOpened, setNextSimulationStep])
  
  React.useEffect(() => {
    if(viewerApi) viewerApi.directlyBlockCameraMoving = Boolean(afterLeverAnimationProgress || boxActiveStep || simulationSelectActive || !activeSimulation)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [afterLeverAnimationProgress, simulationSelectActive, boxActiveStep, activeSimulation])

  React.useEffect(() => {
    if(viewerApi) viewerApi.LeversControler.reset(isReverseLevers)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showLevers])

  React.useEffect(() => {
    if(activeSimulation) {
      setPositionReady(false)
      viewerApi!.startLandingAudio()

      const { additionalCamPos } = activeSimulation
      viewerApi!.initSimulation(activeSimulation)
        .then(() => {
          setPositionReady(true);
          (!additionalCamPos || isRemote) && setSimulationSidePanelActive(true)
          setShade(true)    
        })
        .then(() => {
          if(additionalCamPos && !isRemote) {
            viewerApi!.isControlBox = true
            viewerApi!.ControlBox.initBox(activeSimulation.controlBox!, boxActiveStep!)
            setSimulationSidePanelActive(true)
            viewerApi!.ControlBox.updateBox(boxActiveStep!)
          }
          if(activeSimulation.counter && activeSimulation.counter.type === 'engine') {
            viewerApi!.Simulations!.getSimById(activeSimulation.id).animationForwards(true)
          }
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeSimulation, viewerApi])

  React.useEffect(() => {
    if(boxActiveStep) {
      if(isRemote) {
        // viewerApi!.resetControlBox(isRemote)
        
      } else {
        viewerApi!.ControlBox!.updateBox(boxActiveStep)
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [boxActiveStep, isRemote])
  
  React.useEffect(() => {
    if(viewerApi && viewerApi!.ControlBox) {
      
      // viewerApi!.resetControlBox()
    }
  }, [viewerApi])

  React.useEffect(() => {
    setEnginePower(0)
  }, [isRemote, activeSimulation])
  
  const blurNode = (isBlur: boolean = !blur, ratio = blurRatio ) => {
    return new Promise((resolve) => {
      setBlur(isBlur)
      if(viewerApi) viewerApi.isBlur = isBlur
      setBlurRatio(ratio)
      setTimeout(resolve, blurTransition)
    })
  }

  
  const setLabelsPositions = ({x, y}: {x: number, y: number}, b: Boolean) => {
    if(laversDom.current) {
      laversDom.current.style!.top = y + -100 + 'px'
      laversDom.current.style!.left = x + (b ? 40 : -100) + 'px'
    }  
  }     

  const setWaterTrackPositions = ({x, y}: {x: number, y: number}) => {
    if(waterTrack.current) {
      const targetTop = y + -217
      waterTrack.current.style!.top = (targetTop < -45 ? -45 : targetTop) + 'px'
      waterTrack.current.style!.left = x + -38 + 'px'
    }  
  }     

  const onBoxButtonPressed = () => {
    boxButtonPressed()
  }

  React.useEffect(() => {
    const viewerApi = new Viewer({ 
      node: viewerNode.current!,
      setEnginePower,
      blurToggler: blurNode,
      canvas: canvasNode.current,
      setPositionReady: setPositionReady,
      onIncrement: incrementCounter,
      landingAudio,
      setLaverPos: setLabelsPositions,
      setWaterTrackPositions,
      onBoxPressEnd: onBoxButtonPressed,
      setAVSP,
      freestyleData: freestyle,
      setFreestyleApi,
      onRemoteButtonClick: ThrowButtonEvent
    })

    setViewerApi(viewerApi)
    
    viewerApi.endActiveSimulation = () => {
      endActiveSimulation()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  let clicked = false
  const openSimulationSelect = async () => {
    if(!clicked) {
      
      if(!blur) {
        clicked = true
        viewerApi!.stopLandingAudio()
        setBlurTransition(500)
        await blurNode(true)
        setSimulationSelect(true)
        setTimeout(() => {
          clicked = false
        }, 2000);
      }
    }
  }
  
  return (
    <div className={styles.root}>
      <div 
        className={`
          ${styles.scene}
          ${shade && styles.shade}
        `}
        onMouseDown={() => !isDone && setContentOpened(false)}
      >
        {
          <div className={
            `${styles.logo} ${!blur && styles.logo_active}`
          }></div>
        }
          
        <div className={styles.scene_wrapper} ref={viewerNode}>
          <canvas 
            style={{
              transition: `all ${blurTransition / 1000}s`,
              filter: blur && `blur(${blurRatio}px)`
            }}
            className={`
              ${styles.scene_holder} 
              ${blur && styles.blur}
            `}
            ref={canvasNode}
            />
        </div>
        <div className={`${styles.button} ${!blur && styles.button_active}`}>
          {
            !isSimulationProgress && !blur &&
              <>
                <div className={styles.button_wrapper}>
                  <div className={`${styles.button_begin} ${freestyleActive ? styles.hidden : ''}`} onClick={initFreestyle}>
                    begin simulator 
                  </div>
                  <div className={`${styles.button_tutorial} ${freestyleActive ? styles.hidden : ''}`} onClick={openSimulationSelect}>
                    practice a tutorial
                  </div>
                  <span className={`${styles.return} ${freestyleActive ? styles.return_active : ''}`}>
                    <div className={styles.button_return} onClick={stopFreestyle}>
                      return to main menu
                    </div>
                  </span>
                </div>
              </>
          }
          <span className={styles.copyright}> CREATED BY MIND-BLOWN.CA </span>
        </div>
        {
        !viewerLoaded && 
          <div className={`
              ${styles.scene_image} 
              ${styles.scene_holder} 
              ${styles.blur}
              ${styles.withImage}
          `}/>
        }
        { blur && blurRatio === 10 && isRemote && activeSimulation &&
            <div
              style={{
                width: '100%',
                height: '100%',
                left: '0',
                top: '0',
                position: 'absolute',
                zIndex: 5,
              }}
              onMouseDown={() => blurNode(false)}>

            </div>
        }
        <Engine 
          show={Boolean(isEngine && enginePower && positionReady && !isDone) || isFreestyleEngine}
          power={isFreestyleEngine ? freestyleEnginePower : enginePower}
          center={Boolean(isRemote || !activeSimulation)}
          />
        {
        <WaterTrack 
          settedRef={waterTrack}
          show={Boolean(positionReady && boxActiveStep && boxActiveStep.type === 'waterTrack')}
        />
        }
        <LeversTrack 
          show={Boolean(showLevers && positionReady)} 
          settedRef={laversDom}
          reverse={isReverseLevers}
        />
        {
          freestyleActive ?
            <UserCameraControls/>
            :
            null
        }
      </div>
    </div>
  );
};



export default connect(
  (state: GlobalState) => ({
    freestyleActive: state.freestyle.active,
    freestyleActiveSimulation: getActiveItemObject(state)
  }),
  dispatch => bindActionCreators(freestyleActions, dispatch)
)(Scene)